module.exports = __webpack_public_path__ + "img/logo.b1794888.svg";